import React from 'react'
import VerificationModal from '../../verificationModal'
import { useApplicationContext } from '../context'
import type { primitives } from '@adc/blueprint'
import type { Maybe } from '@adc/sdk/types'

const ApplicationVerificationModal = ({
  close,
  onClose,
  onSuccess,
}: {
  close: () => {}
  onClose: Maybe<() => {}>
  onSuccess: Maybe<() => {}>
}) => {
  const ctx = useApplicationContext()
  const callCbAndClose = (cb: Maybe<() => {}>) => () => {
    cb?.()
    close()
  }

  return (
    // @ts-ignore
    <VerificationModal
      isOpen
      onSuccess={callCbAndClose(onSuccess)}
      onClose={callCbAndClose(onClose)}
      email={(ctx.user as primitives.AuthenticatedAuctionUser).email}
    />
  )
}

export default ApplicationVerificationModal
